export interface Author {
  slug: string;
  name: string;
  bio: string;
  credentials: string;
  role: string;
  portfolio?: string;
}

export const AUTHORS: Record<string, Author> = {
  "uday-kumar": {
    slug: "uday-kumar",
    name: "Dhairya",
    role: "Founder, Acadly",
    credentials:
      "BA (Hons) Economics, University of Delhi. Writes on economics, exam craft and study systems.",
    bio: "Dhairya sat the same DU papers he now writes about. Acadly is his attempt to say the useful things his own first-year self would have wanted to hear.",
    portfolio: "https://dhairya.lol",
  },
};

export const DEFAULT_AUTHOR = AUTHORS["uday-kumar"];